import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAuthenticated } from '../../utils/localUser';
import MessagePage from '../global/MessagePage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated: reduxAuth } = useSelector(state => state.auth.authState);

  // Check both Redux state and localStorage for authentication
  const userIsAuthenticated = reduxAuth || isAuthenticated();

  useEffect(() => {
    if (!userIsAuthenticated) {
      // Redirect to static login page
      window.location.href = '/login.html';
    }
  }, [userIsAuthenticated]);

  // Show loading while checking authentication
  if (!userIsAuthenticated) {
    return <MessagePage color="inherit" />;
  }

  // NOTE: onboarding is no longer forced on profile completion. It's an
  // optional, skippable welcome step driven by "no workspace yet" (see the
  // reconciliation effect in App.js). Forcing it here trapped users who
  // skipped onboarding back into it right after creating their first
  // workspace (profile_completed stays false because the new onboarding
  // screen doesn't collect profile info).
  return children;
};

export default ProtectedRoute;
